
import { Link, Route, Routes } from "react-router-dom";
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import { Button, Form, Row, Col, Container, Card} from 'react-bootstrap';

export const NavbarSmart = (props) => {

  return (

    <Navbar expand="sm" className="bg-body">
      <Container style={{justifyContent: "right"}}>
        <Navbar.Toggle aria-controls="basic-navbar-nav"/>
        <Navbar.Collapse id="basic-navbar-nav">
        
          {/* <Nav className="me-auto"> */}
          <Nav style={{textAlign: "center", margin: "auto"}}>
            {/* always show home */}
            <Nav.Link href={'/'}><Button variant="outline-dark">Home</Button></Nav.Link>
            {/* show login and signup if not protected route */}
            { !props.showLoggedIn  && 
              <>
                <Nav.Link href={'/login'}><Button variant="outline-dark">Login</Button></Nav.Link>
                <Nav.Link href={'/signup'}><Button variant="outline-dark">Signup</Button></Nav.Link>
              </>
            }

            { props.showLoggedIn && 
              <>
                <Nav.Link href={'/dash'}><Button variant="outline-dark">Dashboard</Button></Nav.Link>
                <Nav.Link href={'/companies'}><Button variant="outline-dark">Companies</Button></Nav.Link>
                <Nav.Link href={'/about'}><Button variant="outline-dark">About</Button></Nav.Link>
              </>
            }

          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>

  )

}